//Keep this in sync with //depot/devmain/msoserviceplatform/src/Browser/App/Packages/AppsForOffice/script/SingleSignOnInfo.cs

enum OmexResultCode {
    Success = 0,
    Cancelled = 100,
    ClientError = 400,
    ServerError = 500,
    UnknowError = 600,
}

export default OmexResultCode;
